<template>
    <component :is="directiveComponent" v-if="directiveComponent" :data="data" :message-id="messageId" :line-idx="lineIdx" />
</template>

<script setup lang="ts">
import type {
    ParseActionsEmailDraftAction,
    ParseActionsGenericAction,
    ParseActionsProactiveCoachingOfferAction,
    ParseActionsRolePlaySetupAction,
    ParseActionsRolePlaySummaryAction,
} from "~vue/types/chat";
import { computed } from "vue";

import { resolveDirective } from "../uiDirectiveRegistry";

type UiDirectiveRendererProps = {
    data: ParseActionsRolePlaySetupAction | ParseActionsRolePlaySummaryAction | ParseActionsProactiveCoachingOfferAction | ParseActionsEmailDraftAction | ParseActionsGenericAction;
    messageId: number;
    lineIdx: number;
};

const props = defineProps<UiDirectiveRendererProps>();

const directiveComponent = computed(() => {
    return resolveDirective(props.data.action_name);
});
</script>
